export class HighlightingMatch {
  constructor({ order, item, length }) {
    this.order = order;
    this.length = length || item?.URL?.length || 0;
    this.item = item;
  }
}
